// Module
var code = `<span class="btn btn-link page-info-icon" uib-popover-template="'js/angular/ttyg/templates/modal/helpInfoExternalLink.html'" popover-trigger="'none'" popover-placement="bottom-right" popover-is-open="isPopoverOpen" popover-append-to-body="false" popover-scope="helpInfo"> <i class="icon-info"></i> </span> `;
// Exports
export default code;